(function () {
  'use strict';

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || Shopify.money_format);
    }
    return (cents / 100).toFixed(2);
  }

  function parseJson(el, fallback) {
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return fallback;
    }
  }

  function syncStoreRoutes() {
    if (window.LPStoreRoutes && typeof window.LPStoreRoutes.syncLegacyRoutes === 'function') {
      window.LPStoreRoutes.syncLegacyRoutes();
    }
  }

  function getStoreRootUrl() {
    syncStoreRoutes();
    if (window.LPStoreRoutes && typeof window.LPStoreRoutes.getStoreRoot === 'function') {
      return window.LPStoreRoutes.getStoreRoot();
    }
    var root = (window.routes && window.routes.root_url) || '/';
    if (root.charAt(0) !== '/') root = '/' + root;
    if (root.slice(-1) !== '/') root += '/';
    return root;
  }

  function getShopOrigin() {
    var shopUrl = window.routes && window.routes.shop_url;
    if (shopUrl) return String(shopUrl).replace(/\/$/, '');
    if (window.Shopify && window.Shopify.shop) {
      var shop = String(window.Shopify.shop);
      if (/^https?:\/\//i.test(shop)) return shop.replace(/\/$/, '');
      return 'https://' + shop.replace(/\/$/, '');
    }
    return window.location.origin;
  }

  function isLocalThemeDev() {
    var host = window.location.hostname;
    return host === '127.0.0.1' || host === 'localhost';
  }

  function normalizeStorePath(path, fallback) {
    var value = (path || fallback || '/checkout').trim();
    if (!value) value = fallback || '/checkout';
    if (/^https?:\/\//i.test(value)) return value;
    if (value.charAt(0) !== '/') value = '/' + value.replace(/^\/+/, '');
    return value;
  }

  function getCheckoutPath() {
    syncStoreRoutes();
    if (window.LPStoreRoutes && typeof window.LPStoreRoutes.checkoutPath === 'function') {
      return window.LPStoreRoutes.checkoutPath();
    }
    return normalizeStorePath(getStoreRootUrl() + 'checkout', '/checkout');
  }

  function getCheckoutUrl() {
    syncStoreRoutes();
    if (window.LPStoreRoutes && typeof window.LPStoreRoutes.checkoutUrl === 'function') {
      return window.LPStoreRoutes.checkoutUrl();
    }
    var path = getCheckoutPath();
    if (isLocalThemeDev()) return getShopOrigin() + path;
    return window.location.origin + path;
  }

  function getCartAddUrl() {
    syncStoreRoutes();
    if (window.LPStoreRoutes && typeof window.LPStoreRoutes.cartAddUrl === 'function') {
      return window.LPStoreRoutes.cartAddUrl();
    }
    return normalizeStorePath((window.routes && window.routes.cart_add_url) || '/cart/add', '/cart/add');
  }

  function getCartAddJsUrl() {
    syncStoreRoutes();
    if (window.LPStoreRoutes && typeof window.LPStoreRoutes.cartAddJsUrl === 'function') {
      return window.LPStoreRoutes.cartAddJsUrl();
    }
    var base = getCartAddUrl();
    if (/\.js(\?|$)/i.test(base)) return base;
    return base.replace(/\/$/, '') + '.js';
  }

  function getCartClearJsUrl() {
    syncStoreRoutes();
    if (window.LPStoreRoutes && typeof window.LPStoreRoutes.cartClearJsUrl === 'function') {
      return window.LPStoreRoutes.cartClearJsUrl();
    }
    var base = normalizeStorePath((window.routes && window.routes.cart_url) || '/cart', '/cart');
    if (/\.js(\?|$)/i.test(base)) return base.replace(/\/clear\.js/i, '') + '/clear.js';
    return base.replace(/\/$/, '') + '/clear.js';
  }

  function isBuyNowCheckout(errorSource) {
    return errorSource === 'lp-pdp-buy-now' || errorSource === 'lp-pdp-sticky-bar';
  }

  function clearCartForBuyNow() {
    return fetch(getCartClearJsUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    }).catch(function () {
      return null;
    });
  }

  function resolveCheckoutVariantId(form, root) {
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    var resolvedId = NaN;

    if (root) {
      var variants = parseJson(root.querySelector('[data-lp-pdp-variants]'), []);
      var selectedScript = root.querySelector('[data-selected-variant]');
      if (selectedScript && selectedScript.textContent) {
        try {
          var parsed = JSON.parse(selectedScript.textContent);
          if (parsed && parsed.id) resolvedId = parseInt(String(parsed.id), 10);
        } catch (e) {}
      }

      if (!resolvedId || isNaN(resolvedId)) {
        var checked = root.querySelector(
          '.lp-pdp-model-grid input[type="radio"]:checked:not(:disabled), .lp-pdp-variant-selects input[type="radio"]:checked:not(:disabled)'
        );
        if (checked && variants.length) {
          var needle = (checked.value || '').toLowerCase().trim();
          for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];
            var haystack = ((variant.title || '') + ' ' + (variant.public_title || '') + ' ' + (variant.name || '')).toLowerCase();
            if (needle && haystack.indexOf(needle) > -1) {
              resolvedId = parseInt(String(variant.id), 10);
              break;
            }
          }
        }
      }

      if (!resolvedId || isNaN(resolvedId)) {
        var active = getActiveVariantFromDom(root, variants);
        if (active && active.id) resolvedId = parseInt(String(active.id), 10);
      }
    }

    if (!resolvedId || isNaN(resolvedId)) {
      resolvedId = variantInput ? parseInt(String(variantInput.value || '').trim(), 10) : NaN;
    }

    if (variantInput && resolvedId && !isNaN(resolvedId)) {
      variantInput.value = String(resolvedId);
    }

    return resolvedId;
  }

  function getCartUpdateJsUrl() {
    syncStoreRoutes();
    if (window.LPStoreRoutes && typeof window.LPStoreRoutes.cartUpdateJsUrl === 'function') {
      return window.LPStoreRoutes.cartUpdateJsUrl();
    }
    var base = normalizeStorePath((window.routes && window.routes.cart_update_url) || '/cart/update', '/cart/update');
    if (/\.js(\?|$)/i.test(base)) return base;
    return base.replace(/\/$/, '') + '.js';
  }

  var PICKUP_CHECKOUT_SOURCE = 'lp-pdp-pickup';

  function getPickupCartAttributes(triggerButton) {
    var attrs = { Fulfillment: 'Self Pickup' };
    var address = triggerButton && triggerButton.dataset.pickupAddress;
    if (address && String(address).trim()) {
      attrs['Pickup Address'] = String(address).trim();
    }
    return attrs;
  }

  function applyPickupCartAttributes(triggerButton) {
    return fetch(getCartUpdateJsUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: getPickupCartAttributes(triggerButton) })
    }).catch(function () {
      return null;
    });
  }

  function finishCheckout(errorSource, triggerButton) {
    if (errorSource === PICKUP_CHECKOUT_SOURCE) {
      return applyPickupCartAttributes(triggerButton).finally(function () {
        redirectToCheckout();
      });
    }
    redirectToCheckout();
    return Promise.resolve();
  }

  function redirectToCheckout() {
    window.location.assign(getCheckoutUrl());
  }

  function postFormToCheckout(variantId, quantity, isPickup) {
    var temp = document.createElement('form');
    temp.method = 'post';
    temp.action = getCartAddUrl();
    temp.style.display = 'none';

    function addField(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      temp.appendChild(input);
    }

    addField('id', String(variantId));
    addField('quantity', String(quantity));
    if (isPickup) {
      addField('properties[Fulfillment]', 'Self Pickup');
    }
    addField('return_to', getCheckoutUrl());

    document.body.appendChild(temp);
    temp.submit();
  }

  function releaseCheckoutTrigger(triggerButton) {
    if (!triggerButton) return;
    triggerButton.disabled = false;
    triggerButton.removeAttribute('aria-busy');
    triggerButton.classList.remove('loading');
    delete triggerButton.dataset.lpPdpCheckoutBusy;
  }

  function resetLpPdpPurchaseUi() {
    document.querySelectorAll('.lp-pdp-layout').forEach(function (layout) {
      layout.classList.remove('lp-pdp-purchase--locked');

      var sectionId = '';
      var info = layout.querySelector('product-info[data-section]');
      if (info) sectionId = info.getAttribute('data-section') || '';
      if (!sectionId) {
        var sectionHost = layout.closest('[data-section]');
        if (sectionHost) sectionId = sectionHost.getAttribute('data-section') || '';
      }
      if (!sectionId) return;

      var submitBtn = document.getElementById('Product-Submit-Button-' + sectionId);
      var buyNow = document.getElementById('Product-BuyNow-Button-' + sectionId);
      var stickyBuy = layout.querySelector('[data-lp-pdp-sticky-buy-now]');

      if (buyNow) releaseCheckoutTrigger(buyNow);
      if (stickyBuy) releaseCheckoutTrigger(stickyBuy);

      if (submitBtn && submitBtn.name === 'add' && !submitBtn.hasAttribute('disabled')) {
        submitBtn.style.display = '';
        releaseCheckoutTrigger(submitBtn);
      }

      var productForm = layout.querySelector('product-form');
      if (productForm) productForm.isloading = false;
    });
  }

  function checkoutFromProductForm(form, triggerButton, errorSource) {
    syncStoreRoutes();
    var root = form
      ? form.closest('.lp-pdp-layout') ||
        form.closest('.product-container') ||
        form.closest('product-info')?.closest('.product-container')
      : null;
    var quantityInput = form ? form.querySelector('[name="quantity"]') : null;
    var variantId = resolveCheckoutVariantId(form, root);
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    var buyNowFlow = isBuyNowCheckout(errorSource);

    if (!variantId || isNaN(variantId)) {
      redirectToCheckout();
      return Promise.resolve(false);
    }

    if (triggerButton) {
      if (triggerButton.dataset.lpPdpCheckoutBusy === 'true') {
        return Promise.resolve(false);
      }
      triggerButton.dataset.lpPdpCheckoutBusy = 'true';
      triggerButton.setAttribute('aria-busy', 'true');
      triggerButton.classList.add('loading');
    }

    var checkoutRequest = function () {
      return fetch(getCartAddJsUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      });
    };

    var startCheckout = buyNowFlow ? clearCartForBuyNow().then(checkoutRequest) : checkoutRequest();

    return startCheckout
      .then(function (res) {
        if (!res.ok) {
          throw new Error('cart_add_failed');
        }
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          if (window.webvista && window.PUB_SUB_EVENTS) {
            webvista.publish(PUB_SUB_EVENTS.cartError, {
              source: errorSource || 'lp-pdp-pickup',
              productVariantId: String(variantId),
              errors: response.errors || response.description,
              message: response.message
            });
          }

          var productForm = form && form.closest('product-form');
          if (productForm && typeof productForm.handleErrorMessage === 'function') {
            productForm.handleErrorMessage(response.description || response.message);
          }

          releaseCheckoutTrigger(triggerButton);
          return false;
        }

        return finishCheckout(errorSource, triggerButton).then(function () {
          return true;
        });
      })
      .catch(function () {
        releaseCheckoutTrigger(triggerButton);
        postFormToCheckout(variantId, quantity, errorSource === PICKUP_CHECKOUT_SOURCE);
        return false;
      });
  }

  function getVariantId(root) {
    var section = root.closest('[data-section]')?.dataset.section;
    var selectors = [];
    if (section) {
      selectors.push('#product-form-' + section + ' input[name="id"]');
      selectors.push('product-form[data-section="' + section + '"] input[name="id"]');
    }
    selectors.push('input.product-variant-id[name="id"]');
    selectors.push('form[data-type="add-to-cart-form"] input[name="id"]');

    for (var i = 0; i < selectors.length; i++) {
      var input = root.querySelector(selectors[i]) || document.querySelector(selectors[i]);
      if (input && input.value) return String(input.value).trim();
    }
    return null;
  }

  function getActiveVariantFromDom(root, variants) {
    var id = getVariantId(root);
    if (id) {
      var matched = findVariant(variants, id);
      if (matched) return matched;
    }

    var selectedScript = root.querySelector('[data-selected-variant]');
    if (selectedScript && selectedScript.textContent) {
      try {
        var parsed = JSON.parse(selectedScript.textContent);
        if (parsed && parsed.id) return parsed;
      } catch (e) {}
    }

    return null;
  }

  function isPickupModelSelected(root, matchToken) {
    var token = (matchToken || 'l2500').toLowerCase();
    var checked = root.querySelector(
      '.lp-pdp-model-grid input[type="radio"]:checked, .lp-pdp-variant-selects input[type="radio"]:checked'
    );
    if (!checked) return false;

    var label = checked.id ? root.querySelector('label[for="' + checked.id + '"]') : null;
    var text = ((label && label.textContent) || checked.value || '').toLowerCase();
    return text.indexOf(token) > -1;
  }

  function findVariant(variants, id) {
    return variants.find(function (v) {
      return String(v.id) === String(id);
    });
  }

  function variantAllowsPickup(variant, matchToken) {
    if (!variant) return false;
    var token = (matchToken || 'l2500').toLowerCase();
    var haystack = ((variant.title || '') + ' ' + (variant.sku || '')).toLowerCase();
    return haystack.indexOf(token) > -1;
  }

  function isL1500Variant(variant, root) {
    if (variant) {
      var haystack = ((variant.title || '') + ' ' + (variant.sku || '')).toLowerCase();
      if (haystack.indexOf('l2500') > -1) return false;
      if (haystack.indexOf('l1500') > -1) return true;
    }

    return isPickupModelSelected(root, 'l1500') && !isPickupModelSelected(root, 'l2500');
  }

  function syncPickupVisibility(root, variant) {
    var btn = root.querySelector('[data-lp-pdp-pickup]');
    if (!btn) return;

    if (btn.dataset.pickupForceVisible === 'true') {
      btn.hidden = false;
      btn.removeAttribute('hidden');
      btn.classList.remove('lp-pdp-pickup--hidden');
      return;
    }

    var variants = parseJson(root.querySelector('[data-lp-pdp-variants]'), []);
    var activeVariant = variant || getActiveVariantFromDom(root, variants);
    var hideForL1500 = isL1500Variant(activeVariant, root);

    btn.hidden = hideForL1500;
    btn.classList.toggle('lp-pdp-pickup--hidden', hideForL1500);
    if (!hideForL1500) btn.removeAttribute('hidden');
  }

  function updateSaveBadge(root, variant) {
    var badge = root.querySelector('[data-lp-pdp-save]');
    if (!badge) return;
    var savings = variant.compare_at_price > variant.price ? variant.compare_at_price - variant.price : 0;
    if (savings > 0) {
      badge.textContent = 'Save ' + money(savings);
      badge.classList.remove('lp-pdp-is-hidden');
    } else {
      badge.textContent = '';
      badge.classList.add('lp-pdp-is-hidden');
    }
  }

  function getLpPdpSectionId(root) {
    var sectionEl = root.querySelector('[data-section]') || root.closest('[data-section]');
    return sectionEl && sectionEl.dataset.section;
  }

  function updateShopMonthlyLine(root, variant) {
    var line = root.querySelector('[data-lp-pdp-financing-shopify-line]');
    if (!line || !variant) return;
    var months = parseInt(line.dataset.shopMonths, 10) || 12;
    var amount = money(Math.round(variant.price / months));
    var amountEl = line.querySelector('[data-lp-pdp-shop-amount]');
    if (amountEl) {
      amountEl.textContent = amount;
    } else {
      var textWrap = line.querySelector('.lp-pdp-financing__shop-line-text');
      if (textWrap) {
        textWrap.innerHTML = 'From <span data-lp-pdp-shop-amount>' + amount + '</span>/mo with';
      } else {
        line.innerHTML =
          '<span class="lp-pdp-financing__shop-line-text">From <span data-lp-pdp-shop-amount>' +
          amount +
          '</span>/mo with</span>';
      }
    }
    var modalEstimate = root.querySelector('[data-lp-pdp-financing-modal-estimate]');
    if (modalEstimate) modalEstimate.textContent = amount;
    line.classList.remove('lp-pdp-is-hidden');
  }

  function parseShopTermsAmount(text) {
    if (!text) return '';
    var match = text.match(/From\s+(\$[\d,.]+|\£[\d,.]+|€[\d,.]+)\s*\/?\s*mo/i);
    if (match) return match[1];
    match = text.match(/(\$[\d,.]+|\£[\d,.]+|€[\d,.]+)/);
    return match ? match[1] : '';
  }

  function openShopPaymentTerms(root) {
    var termsHost = root.querySelector('.lp-pdp-financing__shopify-terms');
    if (!termsHost) return false;
    var termsEl = termsHost.querySelector('shopify-payment-terms');
    if (!termsEl) return false;

    if (typeof termsEl.showModal === 'function') {
      try {
        termsEl.showModal();
        return true;
      } catch (err) {
        /* fall through to shadow trigger */
      }
    }

    var shadow = termsEl.shadowRoot;
    if (shadow) {
      var selectors = [
        'button[aria-label*="installment" i]',
        'button[aria-label*="Shop Pay" i]',
        'button[aria-label*="shop pay" i]',
        'button[aria-label*="Affirm" i]',
        'a[href*="affirm" i]',
        'button[type="button"]',
        'button',
        '[role="button"]'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var trigger = shadow.querySelector(selectors[i]);
        if (trigger) {
          trigger.click();
          return true;
        }
      }
    }

    return false;
  }

  function openFinancingModal(financingRoot) {
    if (!financingRoot) return;
    var modal = financingRoot.querySelector('[data-lp-pdp-financing-modal]');
    if (!modal || modal.hidden === false && modal.classList.contains('is-visible')) return;
    modal.hidden = false;
    window.requestAnimationFrame(function () {
      modal.classList.add('is-visible');
    });
    var card = modal.querySelector('.lp-pdp-financing__modal-card');
    if (card) card.focus();
  }

  function closeFinancingModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-visible');
    window.setTimeout(function () {
      modal.hidden = true;
    }, 280);
  }

  function initFinancingModal(financingRoot) {
    if (!financingRoot || financingRoot.dataset.lpPdpFinancingModalInit === 'true') return;
    financingRoot.dataset.lpPdpFinancingModalInit = 'true';

    var modal = financingRoot.querySelector('[data-lp-pdp-financing-modal]');
    if (!modal) return;

    financingRoot.querySelectorAll('[data-lp-pdp-financing-modal-close]').forEach(function (closeEl) {
      closeEl.addEventListener('click', function () {
        closeFinancingModal(modal);
      });
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Escape' || modal.hidden) return;
      closeFinancingModal(modal);
    });
  }

  function tryOpenShopTermsWithFallback(root, financingRoot) {
    var termsHost = root.querySelector('.lp-pdp-financing__shopify-terms');
    if (!termsHost) {
      openFinancingModal(financingRoot);
      return;
    }

    if (openShopPaymentTerms(root)) return;

    var attempts = 0;
    var opened = false;
    var pollTimer = null;
    var fallbackTimer = window.setTimeout(function () {
      if (!opened) openFinancingModal(financingRoot);
    }, 900);

    function clearFallbackTimer() {
      if (fallbackTimer) {
        window.clearTimeout(fallbackTimer);
        fallbackTimer = null;
      }
    }

    function attempt() {
      if (openShopPaymentTerms(root)) {
        opened = true;
        clearFallbackTimer();
        if (pollTimer) window.clearInterval(pollTimer);
        return true;
      }
      return false;
    }

    function startPolling() {
      if (opened || pollTimer) return;
      pollTimer = window.setInterval(function () {
        attempts += 1;
        if (attempt() || attempts >= 6) {
          window.clearInterval(pollTimer);
          pollTimer = null;
          if (!opened && !fallbackTimer) openFinancingModal(financingRoot);
        }
      }, 200);
    }

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('shopify-payment-terms').then(startPolling).catch(startPolling);
      return;
    }

    startPolling();
  }

  function initShopPaymentTerms(root) {
    var financingRoot = root.querySelector('[data-lp-pdp-financing]');
    if (financingRoot) initFinancingModal(financingRoot);

    var btns = root.querySelectorAll('[data-lp-pdp-shop-terms-open]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      if (btn.dataset.lpPdpShopTermsInit === 'true') return;
      btn.dataset.lpPdpShopTermsInit = 'true';

      btn.addEventListener('click', function () {
        tryOpenShopTermsWithFallback(root, financingRoot);
      });
    });
  }

  function updateFinancingEstimates(root, variant) {
    if (!variant) return;

    updateShopMonthlyLine(root, variant);

    var section = getLpPdpSectionId(root);
    var instInput = section
      ? document.querySelector('#product-form-installment-' + section + ' input[name="id"]')
      : null;
    if (instInput) instInput.value = variant.id;

    window.setTimeout(function () {
      syncShopifyPaymentTermsLine(root, variant);
    }, 120);
  }

  function syncShopifyPaymentTermsLine(root, variant) {
    var termsHost = root.querySelector('.lp-pdp-financing__shopify-terms');
    var line = root.querySelector('[data-lp-pdp-financing-shopify-line]');
    if (!line) return;

    var text = '';
    if (termsHost) {
      var termsEl = termsHost.querySelector('shopify-payment-terms');
      if (termsEl) {
        text = (termsEl.shadowRoot && termsEl.shadowRoot.textContent) || termsEl.textContent || '';
        text = text.replace(/\s+/g, ' ').trim();
      }
    }

    if (text) {
      var amountEl = line.querySelector('[data-lp-pdp-shop-amount]');
      var parsedAmount = parseShopTermsAmount(text);
      if (amountEl && parsedAmount) {
        amountEl.textContent = parsedAmount;
      }
    } else if (variant) {
      updateShopMonthlyLine(root, variant);
    }
  }

  function getActiveFeatureList(feature) {
    if (!feature) return null;
    if (feature.hasAttribute('data-lp-pdp-feature-dual')) {
      var visible = feature.querySelector('[data-lp-pdp-feature-list]:not([hidden])');
      if (visible) return visible;
      return feature.querySelector('[data-lp-pdp-feature-list][data-lp-pdp-feature-model="l2500"]');
    }
    return feature.querySelector('[data-lp-pdp-feature-list]');
  }

  function syncFeatureModel(root, variant) {
    var feature = root.querySelector('[data-lp-pdp-feature-dual]');
    if (!feature) return;
    var model = isL1500Variant(variant, root) ? 'l1500' : 'l2500';
    feature.querySelectorAll('[data-lp-pdp-feature-list]').forEach(function (ul) {
      var match = ul.getAttribute('data-lp-pdp-feature-model') === model;
      ul.hidden = !match;
    });
    var toggle = feature.querySelector('[data-lp-pdp-feature-toggle]');
    var active = getActiveFeatureList(feature);
    if (toggle && active && active.id) {
      toggle.setAttribute('aria-controls', active.id);
    }
    if (typeof feature._lpRefreshFeature === 'function') {
      feature._lpRefreshFeature(true);
    }
  }

  function onVariantChange(root, variant) {
    if (!variant) return;
    updateSaveBadge(root, variant);
    updateFinancingEstimates(root, variant);
    syncPickupVisibility(root, variant);
    syncFeatureModel(root, variant);
  }

  function initFeatureToggle(root) {
    var feature = root.querySelector('[data-lp-pdp-feature]');
    if (!feature || feature.dataset.lpPdpFeatureInit === 'true') return;
    feature.dataset.lpPdpFeatureInit = 'true';

    var viewport = feature.querySelector('[data-lp-pdp-feature-viewport]');
    var list = getActiveFeatureList(feature);
    var fade = feature.querySelector('[data-lp-pdp-feature-fade]');
    var toggle = feature.querySelector('[data-lp-pdp-feature-toggle]');
    var toggleText = feature.querySelector('[data-lp-pdp-feature-toggle-text]');
    var chevron = feature.querySelector('[data-lp-pdp-feature-chevron]');
    if (!viewport || !list || !fade || !toggle || !toggleText) return;

    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var expanded = false;
    var resizeObserver = null;

    function prefersReducedMotion() {
      return motionQuery.matches;
    }

    function getItems() {
      return Array.from(list.querySelectorAll('.lp-pdp-feature__item'));
    }

    function measureCollapsedHeight() {
      var items = getItems();
      if (items.length <= 3) return list.scrollHeight;

      var listTop = list.getBoundingClientRect().top;
      var item3Bottom = items[2].getBoundingClientRect().bottom - listTop;
      var height = item3Bottom;
      var peekRatio = 0.42;

      if (items[3]) {
        height += items[3].offsetHeight * peekRatio;
      }
      if (items[4]) {
        height += parseFloat(window.getComputedStyle(items[4]).marginTop) || 0;
        height += items[4].offsetHeight * peekRatio;
      }

      return Math.ceil(height);
    }

    function clearTextMask() {
      viewport.style.removeProperty('-webkit-mask-image');
      viewport.style.removeProperty('mask-image');
      viewport.style.removeProperty('-webkit-mask-repeat');
      viewport.style.removeProperty('mask-repeat');
      viewport.style.removeProperty('-webkit-mask-size');
      viewport.style.removeProperty('mask-size');
    }

    function applyTextMask(collapsedHeight) {
      var items = getItems();
      if (items.length <= 3) {
        clearTextMask();
        fade.style.setProperty('--lp-pdp-feature-fade-height', '0px');
        return;
      }

      var listTop = list.getBoundingClientRect().top;
      var item3Bottom = items[2].getBoundingClientRect().bottom - listTop;
      var fadeStart = Math.min(Math.max((item3Bottom / collapsedHeight) * 100, 52), 78);
      var fadeMid = Math.min(fadeStart + 7, 90);
      var fadeSoft = Math.min(fadeStart + 16, 97);
      var gradient =
        'linear-gradient(to bottom, #000 0%, #000 ' +
        fadeStart.toFixed(1) +
        '%, rgba(0,0,0,0.52) ' +
        fadeMid.toFixed(1) +
        '%, rgba(0,0,0,0.16) ' +
        fadeSoft.toFixed(1) +
        '%, transparent 100%)';

      viewport.style.setProperty('-webkit-mask-image', gradient);
      viewport.style.setProperty('mask-image', gradient);
      viewport.style.setProperty('-webkit-mask-repeat', 'no-repeat');
      viewport.style.setProperty('mask-repeat', 'no-repeat');
      viewport.style.setProperty('-webkit-mask-size', '100% 100%');
      viewport.style.setProperty('mask-size', '100% 100%');

      var fadeHeight = Math.max(Math.ceil(collapsedHeight - item3Bottom + 8), 64);
      fade.style.setProperty('--lp-pdp-feature-fade-height', fadeHeight + 'px');
    }

    function applyCollapsed(instant) {
      var collapsedHeight = measureCollapsedHeight();
      if (instant || prefersReducedMotion()) {
        viewport.style.transition = 'none';
        fade.style.transition = 'none';
      }

      expanded = false;
      feature.classList.remove('is-expanded');
      feature.classList.add('is-masked');
      viewport.style.maxHeight = collapsedHeight + 'px';
      applyTextMask(collapsedHeight);
      fade.hidden = false;
      fade.style.visibility = 'visible';
      fade.style.opacity = '1';
      toggle.setAttribute('aria-expanded', 'false');
      toggleText.textContent = 'Read more';
      if (chevron) chevron.classList.remove('is-up');

      if (instant || prefersReducedMotion()) {
        requestAnimationFrame(function () {
          viewport.style.transition = '';
          fade.style.transition = '';
        });
      }
    }

    function applyExpanded(instant) {
      var fullHeight = list.scrollHeight;
      if (instant || prefersReducedMotion()) {
        viewport.style.transition = 'none';
        fade.style.transition = 'none';
        viewport.style.maxHeight = fullHeight + 'px';
        clearTextMask();
        fade.hidden = true;
        fade.style.opacity = '0';
        fade.style.visibility = 'hidden';
        feature.classList.remove('is-masked');
        expanded = true;
        feature.classList.add('is-expanded');
        toggle.setAttribute('aria-expanded', 'true');
        toggleText.textContent = 'Show less';
        if (chevron) chevron.classList.add('is-up');
        requestAnimationFrame(function () {
          viewport.style.transition = '';
          fade.style.transition = '';
        });
        return;
      }

      expanded = true;
      toggle.setAttribute('aria-expanded', 'true');
      toggleText.textContent = 'Show less';
      if (chevron) chevron.classList.add('is-up');
      viewport.style.maxHeight = fullHeight + 'px';
      fade.style.opacity = '0';

      viewport.addEventListener(
        'transitionend',
        function onExpandEnd(event) {
          if (event.propertyName !== 'max-height') return;
          viewport.removeEventListener('transitionend', onExpandEnd);
          clearTextMask();
          fade.hidden = true;
          fade.style.visibility = 'hidden';
          feature.classList.remove('is-masked');
          feature.classList.add('is-expanded');
        },
        { once: true }
      );
    }

    function onToggle() {
      if (expanded) applyCollapsed(false);
      else applyExpanded(false);
    }

    toggle.addEventListener('click', onToggle);
    toggle.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      onToggle();
    });

    motionQuery.addEventListener('change', function () {
      if (expanded) applyExpanded(true);
      else applyCollapsed(true);
    });

    function rebindActiveList() {
      var next = getActiveFeatureList(feature);
      if (next === list) return;
      if (feature._lpFeatureResizeObserver && list) {
        try {
          feature._lpFeatureResizeObserver.unobserve(list);
        } catch (e) {}
      }
      list = next;
      if (feature._lpFeatureResizeObserver && list) {
        feature._lpFeatureResizeObserver.observe(list);
      }
    }

    function refreshHeight() {
      rebindActiveList();
      if (!list) return;
      if (expanded) {
        viewport.style.maxHeight = list.scrollHeight + 'px';
        return;
      }
      applyCollapsed(true);
    }

    feature._lpRefreshFeature = function (instant) {
      rebindActiveList();
      if (!list) return;
      expanded = false;
      feature.classList.remove('is-expanded');
      applyCollapsed(!!instant);
    };

    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(refreshHeight);
      resizeObserver.observe(list);
      feature._lpFeatureResizeObserver = resizeObserver;
    } else {
      window.addEventListener('resize', refreshHeight);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        refreshHeight();
      });
    }

    applyCollapsed(true);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        applyCollapsed(true);
      });
    });
    window.setTimeout(function () {
      if (!expanded) applyCollapsed(true);
    }, 120);
  }

  function initLpPdpBuyNow(root) {
    if (root.querySelector('[data-lp-pdp-netrtk]')) return;

    var sectionId = root.getAttribute('data-section') || root.dataset.section;
    if (!sectionId) {
      var sectionEl = root.closest('[data-section]');
      sectionId = sectionEl ? sectionEl.getAttribute('data-section') : '';
    }
    if (!sectionId) return;

    var buyNow = document.getElementById('Product-BuyNow-Button-' + sectionId);
    if (!buyNow || buyNow.dataset.lpPdpBuyNowInit === 'true') return;
    buyNow.dataset.lpPdpBuyNowInit = 'true';

    root.classList.remove('lp-pdp-purchase--locked');

    var submitBtn = document.getElementById('Product-Submit-Button-' + sectionId);
    if (submitBtn) submitBtn.style.display = '';

    buyNow.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      releaseCheckoutTrigger(buyNow);
      checkoutFromProductForm(root.querySelector('product-form form'), buyNow, 'lp-pdp-buy-now');
    });
  }

  function initNetrtkCheck(root) {
    var wrap = root.querySelector('[data-lp-pdp-netrtk]');
    if (!wrap || wrap.dataset.lpPdpNetrtkInit === 'true') return;
    wrap.dataset.lpPdpNetrtkInit = 'true';

    var sectionId = wrap.dataset.sectionId;
    var productId = wrap.dataset.productId;
    var storageKey = 'lp-pdp-netrtk-' + productId;
    var input = wrap.querySelector('[data-lp-pdp-netrtk-input]');
    var submitBtn = wrap.querySelector('[data-lp-pdp-netrtk-submit]');
    var resultEl = wrap.querySelector('[data-lp-pdp-netrtk-result]');
    var group = wrap.querySelector('[data-lp-pdp-netrtk-group]');

    function isNetrtkPill(btn) {
      var val = (btn.getAttribute('data-rtk-value') || '').toLowerCase().trim();
      if (val === 'rtk') return false;
      return val.indexOf('netrtk') > -1 || val.indexOf('net rtk') > -1 || val === 'nrtk';
    }

    function isRtkPill(btn) {
      return !isNetrtkPill(btn);
    }

    function getLiveNetrtkWrap() {
      return root.querySelector('[data-lp-pdp-netrtk]');
    }

    function getLiveNetrtkGroup() {
      var liveWrap = getLiveNetrtkWrap();
      return liveWrap ? liveWrap.querySelector('[data-lp-pdp-netrtk-group]') : group;
    }

    function readRtkModeFromPills() {
      var liveGroup = getLiveNetrtkGroup();
      if (!liveGroup) return 'netrtk';
      var active = liveGroup.querySelector('.lp-pdp-netrtk__pill.is-active');
      if (!active) return 'netrtk';
      return isRtkPill(active) ? 'rtk' : 'netrtk';
    }

    function isRtkModeActive() {
      return readRtkModeFromPills() === 'rtk';
    }

    function syncRtkModeFlag() {
      var liveWrap = getLiveNetrtkWrap();
      if (!liveWrap) return;
      liveWrap.dataset.lpPdpRtkMode = readRtkModeFromPills();
    }

    function getBuyNowButton() {
      return document.getElementById('Product-BuyNow-Button-' + sectionId);
    }

    function getSubmitButtonEl() {
      return document.getElementById('Product-Submit-Button-' + sectionId);
    }

    function isClickInside(el, event) {
      return !!(el && event.target && el.contains(event.target));
    }

    function isNetrtkMode() {
      return !isRtkModeActive();
    }

    function isVerified() {
      return wrap.dataset.verified === 'true';
    }

    function setVerified(value) {
      wrap.dataset.verified = value ? 'true' : 'false';
      try {
        if (value) sessionStorage.setItem(storageKey, '1');
        else sessionStorage.removeItem(storageKey);
      } catch (e) {}
    }

    function showResult(text, state) {
      if (!resultEl) return;
      resultEl.hidden = false;
      resultEl.className = 'lp-pdp-netrtk-check__result is-' + state;
      resultEl.textContent = text;
    }

    function clearResult() {
      if (!resultEl) return;
      resultEl.hidden = true;
      resultEl.className = 'lp-pdp-netrtk-check__result';
      resultEl.textContent = '';
    }

    function setDefaultActivePill() {
      var liveGroup = getLiveNetrtkGroup();
      if (!liveGroup) return;
      var pills = liveGroup.querySelectorAll('.lp-pdp-netrtk__pill');
      var netPill = null;
      pills.forEach(function (btn) {
        btn.classList.remove('is-disabled', 'is-active');
        if (isNetrtkPill(btn)) netPill = btn;
      });
      if (netPill) netPill.classList.add('is-active');
      else if (pills.length) pills[0].classList.add('is-active');
      syncRtkModeFlag();
    }

    function resetPills() {
      setDefaultActivePill();
    }

    function activatePill(btn) {
      var liveGroup = getLiveNetrtkGroup();
      if (!liveGroup || !btn) return;
      liveGroup.querySelectorAll('.lp-pdp-netrtk__pill').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      syncRtkModeFlag();
      syncPurchaseUI();
    }

    function scrollToCoverageCheck() {
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (input) {
        window.setTimeout(function () {
          input.focus({ preventScroll: true });
        }, 400);
      }
    }

    function showRtkChoiceModal(rtkButton) {
      if (document.querySelector('[data-lp-pdp-rtk-choice-modal]')) return;

      var scrollY = window.scrollY || window.pageYOffset;
      var previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.width = '100%';

      var overlay = document.createElement('div');
      overlay.className = 'lp-pdp-netrtk-modal lp-pdp-netrtk-modal--rtk-choice';
      overlay.setAttribute('data-lp-pdp-rtk-choice-modal', '');
      overlay.innerHTML =
        '<div class="lp-pdp-netrtk-modal__card" role="dialog" aria-modal="true" aria-labelledby="lp-pdp-rtk-choice-title" tabindex="-1">' +
          '<button type="button" class="lp-pdp-netrtk-modal__close" aria-label="Close dialog">' +
            '<span aria-hidden="true">&times;</span>' +
          '</button>' +
          '<p class="lp-pdp-netrtk-modal__title" id="lp-pdp-rtk-choice-title">Choose the setup that fits your yard</p>' +
          '<p class="lp-pdp-netrtk-modal__desc">When coverage is available, NRTK can provide precise wire-free positioning without a local reference station, making setup simpler.</p>' +
          '<div class="lp-pdp-netrtk-modal__actions">' +
            '<button type="button" class="lp-pdp-netrtk-modal__btn lp-pdp-netrtk-modal__btn--secondary">Continue with RTK</button>' +
            '<button type="button" class="lp-pdp-netrtk-modal__btn lp-pdp-netrtk-modal__btn--primary">Check NRTK coverage</button>' +
          '</div>' +
        '</div>';

      document.body.appendChild(overlay);

      var continueBtn = overlay.querySelector('.lp-pdp-netrtk-modal__btn--secondary');
      var checkBtn = overlay.querySelector('.lp-pdp-netrtk-modal__btn--primary');
      var closeBtn = overlay.querySelector('.lp-pdp-netrtk-modal__close');
      var card = overlay.querySelector('.lp-pdp-netrtk-modal__card');

      function revealModal() {
        overlay.classList.add('is-visible');
        if (card) {
          card.style.opacity = '1';
          card.style.transform = 'scale(1) translateY(0)';
        }
      }

      function unlockScroll() {
        document.body.style.overflow = previousOverflow;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
      }

      function closeModal(returnFocus) {
        if (overlay.dataset.closed === 'true') return;
        overlay.dataset.closed = 'true';
        document.removeEventListener('keydown', onKeydown);
        overlay.classList.remove('is-visible');
        var didFinish = false;
        function finishClose() {
          if (didFinish) return;
          didFinish = true;
          if (overlay.parentNode) overlay.remove();
          unlockScroll();
          if (returnFocus && rtkButton) rtkButton.focus();
        }
        overlay.addEventListener('transitionend', finishClose, { once: true });
        window.setTimeout(finishClose, 400);
      }

      function onKeydown(e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeModal(true);
        }
      }

      document.addEventListener('keydown', onKeydown);

      revealModal();
      requestAnimationFrame(revealModal);
      window.setTimeout(function () {
        if (continueBtn) continueBtn.focus();
      }, 50);

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          closeModal(true);
        });
      }

      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          closeModal(false);
          activatePill(rtkButton);
          var liveWrap = getLiveNetrtkWrap();
          if (liveWrap) liveWrap.dataset.lpPdpRtkMode = 'rtk';
          window.setTimeout(function () {
            if (rtkButton) rtkButton.focus();
          }, 420);
        });
      }

      if (checkBtn) {
        checkBtn.addEventListener('click', function () {
          closeModal(false);
          window.setTimeout(scrollToCoverageCheck, 420);
        });
      }

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal(true);
      });
    }

    function handlePillClick(e) {
      var liveGroup = getLiveNetrtkGroup();
      var btn = e.target.closest('.lp-pdp-netrtk__pill');
      if (!btn || !liveGroup || !liveGroup.contains(btn) || btn.classList.contains('is-disabled')) return;

      if (btn.classList.contains('is-active')) return;

      if (isRtkPill(btn)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showRtkChoiceModal(btn);
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      activatePill(btn);
    }

    function updatePills(canService) {
      var liveGroup = getLiveNetrtkGroup();
      if (!liveGroup) return;
      var pills = liveGroup.querySelectorAll('.lp-pdp-netrtk__pill');
      pills.forEach(function (btn) {
        var val = (btn.getAttribute('data-rtk-value') || '').toLowerCase();
        var isNet = val.indexOf('netrtk') > -1 || val.indexOf('net rtk') > -1 || val === 'nrtk';
        if (isNet) {
          if (!canService) {
            btn.classList.add('is-disabled');
            btn.classList.remove('is-active');
          } else {
            btn.classList.remove('is-disabled');
          }
        }
      });
      if (!canService) {
        pills.forEach(function (btn) {
          var val = (btn.getAttribute('data-rtk-value') || '').toLowerCase();
          var isNet = val.indexOf('netrtk') > -1 || val.indexOf('net rtk') > -1 || val === 'nrtk';
          if (!isNet) btn.classList.add('is-active');
        });
      }
      syncRtkModeFlag();
    }

    function canPurchase() {
      return isVerified();
    }

    function syncPurchaseUI() {
      var buyNow = document.getElementById('Product-BuyNow-Button-' + sectionId);
      if (!buyNow) return;

      var atc = document.getElementById('Product-Submit-Button-' + sectionId);
      var dc = document.getElementById('Dynamic-Checkout-' + sectionId);

      if (canPurchase()) {
        root.classList.remove('lp-pdp-purchase--locked');
        if (buyNow) buyNow.style.display = 'none';
        if (atc) atc.style.display = '';
        if (dc) dc.classList.remove('hidden');
      } else {
        root.classList.add('lp-pdp-purchase--locked');
        if (buyNow) buyNow.style.display = '';
        if (atc) atc.style.display = 'none';
        if (dc) dc.classList.add('hidden');
      }

      syncPickupVisibility(root);
    }

    function showModal() {
      if (document.querySelector('[data-lp-pdp-netrtk-modal]')) return;

      var overlay = document.createElement('div');
      overlay.className = 'lp-pdp-netrtk-modal';
      overlay.setAttribute('data-lp-pdp-netrtk-modal', '');
      overlay.innerHTML =
        '<div class="lp-pdp-netrtk-modal__card" role="dialog" aria-modal="true" aria-labelledby="lp-pdp-netrtk-modal-title">' +
          '<div class="lp-pdp-netrtk-modal__icon" aria-hidden="true">' +
            '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>' +
              '<circle cx="12" cy="10" r="3"/>' +
            '</svg>' +
          '</div>' +
          '<p class="lp-pdp-netrtk-modal__title" id="lp-pdp-netrtk-modal-title">Address Verification Required</p>' +
          '<p class="lp-pdp-netrtk-modal__desc">Please enter and verify your shipping address above before purchasing.</p>' +
          '<button type="button" class="lp-pdp-netrtk-modal__btn">Got it</button>' +
        '</div>';

      document.body.appendChild(overlay);
      requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });

      function close() {
        overlay.classList.remove('is-visible');
        overlay.addEventListener(
          'transitionend',
          function () {
            overlay.remove();
          },
          { once: true }
        );
        window.setTimeout(function () {
          if (overlay.parentNode) overlay.remove();
        }, 400);
      }

      overlay.querySelector('.lp-pdp-netrtk-modal__btn').addEventListener('click', close);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
    }

    function handleLockedBuyNow(event, buyNowBtn) {
      if (canPurchase()) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (isRtkModeActive()) {
        checkoutFromProductForm(root.querySelector('product-form form'), buyNowBtn, 'lp-pdp-buy-now');
        return;
      }

      showModal();
    }

    function blockPurchase(event) {
      if (canPurchase()) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      showModal();
      return true;
    }

    if (submitBtn && input) {
      submitBtn.addEventListener('click', function () {
        var address = input.value.trim();
        if (!address) {
          showResult('Please enter your shipping address', 'error');
          setVerified(false);
          syncPurchaseUI();
          return;
        }
        showResult('Checking...', 'loading');
        submitBtn.disabled = true;

        fetch(
          'https://cluster-us.yjserver.com/app-api/equipment/huace/serviceCoverageByAddress?address=' +
            encodeURIComponent(address),
          { headers: { 'tenant-id': '1' } }
        )
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            submitBtn.disabled = false;
            if (data.code === 200 && data.success) {
              var canService = data.value && data.value.canService === true;
              var msg = canService
                ? 'NetRTK is available in your area!'
                : 'NetRTK is not available in your area, RTK has been selected.';
              updatePills(canService);
              setVerified(true);
              showResult(msg, canService ? 'success' : 'error');
              syncPurchaseUI();
            } else {
              setVerified(false);
              showResult(data.message || 'Check failed', 'error');
              syncPurchaseUI();
            }
          })
          .catch(function () {
            submitBtn.disabled = false;
            setVerified(false);
            showResult('Network error, please try again', 'error');
            syncPurchaseUI();
          });
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitBtn.click();
        }
      });
    }

    if (group) {
      wrap.addEventListener('click', handlePillClick, true);
    }

    var form = root.querySelector('product-form form');
    if (form && form.dataset.lpPdpNetrtkFormInit !== 'true') {
      form.dataset.lpPdpNetrtkFormInit = 'true';
      form.addEventListener(
        'submit',
        function (event) {
          blockPurchase(event);
        },
        true
      );
    }

    root.addEventListener(
      'click',
      function (event) {
        if (canPurchase()) return;

        var buyNowBtn = getBuyNowButton();
        if (buyNowBtn && buyNowBtn.contains(event.target)) {
          handleLockedBuyNow(event, buyNowBtn);
          return;
        }

        var submitBtnEl = getSubmitButtonEl();
        var dynamicCheckout = document.getElementById('Dynamic-Checkout-' + sectionId);
        if (isClickInside(submitBtnEl, event) || isClickInside(dynamicCheckout, event)) {
          blockPurchase(event);
        }
      },
      true
    );

    if (window.webvista && window.PUB_SUB_EVENTS) {
      webvista.subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        if (!evt || !evt.data || evt.data.sectionId !== sectionId) return;
        setVerified(false);
        resetPills();
        clearResult();
        if (input) input.value = '';
        syncPurchaseUI();
      });
    }

    syncRtkModeFlag();
    syncPurchaseUI();
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function copyTextToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        resolve();
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(ta);
      }
    });
  }

  function resolvePickupProductForm(triggerBtn) {
    syncStoreRoutes();

    var formId = triggerBtn.dataset.productFormId;
    var form = formId ? document.getElementById(formId) : null;
    if (!form) {
      var root = triggerBtn.closest('.lp-pdp-layout');
      var productForm = triggerBtn.closest('product-form') || (root && root.querySelector('product-form'));
      form = productForm
        ? productForm.querySelector('form[data-type="add-to-cart-form"]')
        : (root && root.querySelector('product-form form[data-type="add-to-cart-form"]'));
    }
    return form;
  }

  function showPickupLocationModal(triggerBtn) {
    if (document.querySelector('[data-lp-pdp-pickup-modal]')) return;

    var address = (triggerBtn.dataset.pickupAddress || '').trim();
    var email = (triggerBtn.dataset.pickupEmail || 'support@lopkin.com').trim();
    var phone = (triggerBtn.dataset.pickupPhone || '+1(832)726-1645').trim();
    var phoneHref = 'tel:' + phone.replace(/[^\d+]/g, '');
    var safeAddress = escapeHtml(address);
    var safeEmail = escapeHtml(email);
    var safePhone = escapeHtml(phone);

    var scrollY = window.scrollY || window.pageYOffset;
    var previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';

    var overlay = document.createElement('div');
    overlay.className = 'lp-pdp-pickup-modal';
    overlay.setAttribute('data-lp-pdp-pickup-modal', '');
    overlay.innerHTML =
      '<div class="lp-pdp-pickup-modal__card" role="dialog" aria-modal="true" aria-labelledby="lp-pdp-pickup-modal-title" tabindex="-1">' +
        '<button type="button" class="lp-pdp-pickup-modal__close" aria-label="Close dialog">' +
          '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        '<p class="lp-pdp-pickup-modal__title" id="lp-pdp-pickup-modal-title">Pickup Location</p>' +
        '<div class="lp-pdp-pickup-modal__address">' +
          '<p class="lp-pdp-pickup-modal__address-text">' + safeAddress + '</p>' +
          '<button type="button" class="lp-pdp-pickup-modal__copy" data-pickup-copy>Copy</button>' +
        '</div>' +
        '<button type="button" class="lp-pdp-pickup-modal__checkout" data-pickup-checkout>Continue to Checkout</button>' +
        '<div class="lp-pdp-pickup-modal__support">' +
          '<p class="lp-pdp-pickup-modal__contact-lead">If you have any questions, please don\u2019t hesitate to contact us.</p>' +
          '<div class="lp-pdp-pickup-modal__support-links">' +
            '<a class="lp-pdp-pickup-modal__link" href="mailto:' + safeEmail + '">' + safeEmail + '</a>' +
            '<a class="lp-pdp-pickup-modal__link" href="' + phoneHref + '">' + safePhone + '</a>' +
          '</div>' +
          '<div class="lp-pdp-pickup-modal__hours">' +
            '<p class="lp-pdp-pickup-modal__hours-intro">Phone support hours</p>' +
            '<p class="lp-pdp-pickup-modal__hours-label">Monday \u2013 Friday:</p>' +
            '<p class="lp-pdp-pickup-modal__hours-line">10:00 AM \u2013 12:00 AM EST / 10:00 AM \u2013 12:00 AM EDT</p>' +
            '<p class="lp-pdp-pickup-modal__hours-line">4:00 PM \u2013 6:00 AM CET / 4:00 PM \u2013 6:00 AM CEST</p>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    var closeBtn = overlay.querySelector('.lp-pdp-pickup-modal__close');
    var copyBtn = overlay.querySelector('[data-pickup-copy]');
    var checkoutBtn = overlay.querySelector('[data-pickup-checkout]');
    var card = overlay.querySelector('.lp-pdp-pickup-modal__card');
    var copyDefaultLabel = 'Copy';

    function revealModal() {
      overlay.classList.add('is-visible');
      if (card) {
        card.style.opacity = '1';
        card.style.transform = 'scale(1) translateY(0)';
      }
    }

    function unlockScroll() {
      document.body.style.overflow = previousOverflow;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }

    function closeModal(returnFocus) {
      if (overlay.dataset.closed === 'true') return;
      overlay.dataset.closed = 'true';
      document.removeEventListener('keydown', onKeydown);
      overlay.classList.remove('is-visible');
      var didFinish = false;
      function finishClose() {
        if (didFinish) return;
        didFinish = true;
        if (overlay.parentNode) overlay.remove();
        unlockScroll();
        if (returnFocus && triggerBtn) triggerBtn.focus();
      }
      overlay.addEventListener('transitionend', finishClose, { once: true });
      window.setTimeout(finishClose, 400);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal(true);
      }
    }

    document.addEventListener('keydown', onKeydown);

    revealModal();
    requestAnimationFrame(revealModal);

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeModal(true);
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        if (!address) return;
        copyTextToClipboard(address)
          .then(function () {
            copyBtn.textContent = 'Copied to clipboard';
            copyBtn.classList.add('is-copied');
            window.setTimeout(function () {
              copyBtn.textContent = copyDefaultLabel;
              copyBtn.classList.remove('is-copied');
            }, 2000);
          })
          .catch(function () {
            copyBtn.textContent = 'Copy failed';
            window.setTimeout(function () {
              copyBtn.textContent = copyDefaultLabel;
            }, 2000);
          });
      });
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        closeModal(false);
        window.setTimeout(function () {
          checkoutFromProductForm(resolvePickupProductForm(triggerBtn), triggerBtn, 'lp-pdp-pickup');
        }, 120);
      });
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal(true);
    });
  }

  function initPickupLocation(root) {
    var btn = root.querySelector('[data-lp-pdp-pickup]');
    if (!btn || btn.dataset.lpPdpPickupInit === 'true') return;
    btn.dataset.lpPdpPickupInit = 'true';

    var textEl = btn.querySelector('[data-lp-pdp-pickup-text]');
    var defaultLabel = btn.dataset.labelDefault || 'Pickup Location';
    var hoverLabel = btn.dataset.labelHover || defaultLabel;

    function setLabel(label, showAddress) {
      if (textEl) textEl.textContent = label;
      btn.classList.toggle('is-address-visible', !!showAddress);
    }

    btn.addEventListener('mouseenter', function () {
      setLabel(hoverLabel, true);
    });
    btn.addEventListener('mouseleave', function () {
      setLabel(defaultLabel, false);
    });
    btn.addEventListener('focus', function () {
      setLabel(hoverLabel, true);
    });
    btn.addEventListener('blur', function () {
      setLabel(defaultLabel, false);
    });

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (btn.disabled || btn.hidden || btn.classList.contains('lp-pdp-pickup--hidden')) return;

      showPickupLocationModal(btn);
    });

    syncPickupVisibility(root);
    window.setTimeout(function () {
      syncPickupVisibility(root);
    }, 120);
  }

  function initAccessoriesCarousel(root) {
    var section = root.querySelector('[data-lp-pdp-accessories-carousel]');
    if (!section || section.dataset.lpPdpAccCarouselInit === 'true') return;
    section.dataset.lpPdpAccCarouselInit = 'true';

    var viewport = section.querySelector('[data-lp-pdp-acc-viewport]');
    var track = section.querySelector('[data-lp-pdp-acc-track]');
    var nav = section.querySelector('[data-lp-pdp-acc-nav]');
    var pageEl = section.querySelector('[data-lp-pdp-acc-page]');
    var prev = section.querySelector('[data-lp-pdp-acc-prev]');
    var next = section.querySelector('[data-lp-pdp-acc-next]');
    if (!viewport || !track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-lp-pdp-acc-card]'));
    if (!cards.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var gap = 12;
    var activeIndex = 0;
    var programmaticScroll = false;
    var scrollEndTimer = 0;

    function totalCount() {
      return parseInt(section.dataset.lpPdpAccTotal, 10) || cards.length;
    }

    function layoutSlides() {
      var width = viewport.clientWidth;
      if (!width) return width;
      cards.forEach(function (card) {
        card.style.width = width + 'px';
        card.style.flexBasis = width + 'px';
      });
      return width;
    }

    function cardScrollLeft(index) {
      var left = 0;
      for (var i = 0; i < index; i++) {
        left += cards[i].offsetWidth + gap;
      }
      return left;
    }

    function updateNav() {
      if (!nav || !pageEl) return;
      var total = totalCount();

      if (total <= 1) {
        nav.hidden = true;
        return;
      }

      nav.hidden = false;
      pageEl.textContent = activeIndex + 1 + '/' + total;
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
    }

    function goToIndex(index, animate) {
      var total = totalCount();
      var nextIndex = ((index % total) + total) % total;
      if (nextIndex === activeIndex && viewport.scrollLeft === cardScrollLeft(nextIndex)) {
        updateNav();
        return;
      }

      activeIndex = nextIndex;
      programmaticScroll = true;
      layoutSlides();
      viewport.scrollTo({
        left: cardScrollLeft(activeIndex),
        behavior: animate === false || reduced ? 'auto' : 'smooth'
      });
      updateNav();

      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(function () {
        programmaticScroll = false;
        viewport.scrollLeft = cardScrollLeft(activeIndex);
        updateNav();
      }, animate === false || reduced ? 32 : 420);
    }

    function step(dir) {
      var total = totalCount();
      var nextIndex = activeIndex + dir;
      if (nextIndex < 0) nextIndex = total - 1;
      if (nextIndex >= total) nextIndex = 0;
      goToIndex(nextIndex, true);
    }

    function syncIndexFromScroll() {
      if (programmaticScroll) return;

      var scrollLeft = viewport.scrollLeft;
      var index = 0;
      var best = Infinity;

      cards.forEach(function (card, i) {
        var dist = Math.abs(cardScrollLeft(i) - scrollLeft);
        if (dist < best) {
          best = dist;
          index = i;
        }
      });

      activeIndex = index;
      updateNav();
    }

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        step(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        step(1);
      });
    }

    viewport.addEventListener(
      'scroll',
      function () {
        if (programmaticScroll) return;
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = window.setTimeout(syncIndexFromScroll, 80);
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      layoutSlides();
      goToIndex(activeIndex, false);
    });

    section.querySelectorAll('[data-lp-pdp-acc-add]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (btn.disabled || btn.classList.contains('is-loading')) return;

        var card = btn.closest('[data-lp-pdp-acc-card]');
        var variantId = parseInt(card?.dataset.variantId, 10);
        if (!variantId) return;

        btn.classList.add('is-loading');
        fetch(getCartAddJsUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (data.status) {
              throw new Error(data.description || 'Unable to add item');
            }
            if (window.webvista && window.PUB_SUB_EVENTS) {
              webvista.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'lp-pdp-accessory',
                productVariantId: String(variantId),
                cartData: data
              });
            }
            var drawer = document.getElementById('Cart-Drawer');
            if (drawer && !drawer.hasAttribute('data-status-silence')) drawer.show(btn);
            else window.location = window.routes.cart_url;
          })
          .catch(function (err) {
            var pf = root.querySelector('product-form');
            if (pf && typeof pf.handleErrorMessage === 'function') {
              pf.handleErrorMessage(err.message || window.accessibilityStrings?.unknownError);
            }
          })
          .finally(function () {
            btn.classList.remove('is-loading');
          });
      });
    });

    cards.forEach(function (card) {
      card.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () {
          layoutSlides();
          goToIndex(activeIndex, false);
        }, { once: true });
      });
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        layoutSlides();
        goToIndex(activeIndex, false);
      });
    }

    layoutSlides();
    goToIndex(0, false);
    window.setTimeout(function () {
      layoutSlides();
      goToIndex(activeIndex, false);
    }, 120);
  }

  function initAccessories(root) {
    var form = root.querySelector('product-form form');
    if (!form || form.dataset.lpPdpAccessoryInit === 'true') return;
    form.dataset.lpPdpAccessoryInit = 'true';

    form.addEventListener(
      'submit',
      function (event) {
        var checks = root.querySelectorAll('.lp-pdp-accessory__check:checked:not(:disabled)');
        if (!checks.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var pf = root.querySelector('product-form');
        if (!pf || pf.isloading) return;

        var mainId = parseInt(pf.variantIdInput.value, 10);
        var qty = parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1;
        var items = [{ id: mainId, quantity: qty }];
        checks.forEach(function (c) {
          items.push({ id: parseInt(c.value, 10), quantity: 1 });
        });

        pf.startLoading();
        fetch(getCartAddJsUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (data.status) {
              pf.handleErrorMessage(data.description);
              return;
            }
            if (window.webvista && window.PUB_SUB_EVENTS) {
              webvista.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'lp-pdp-buy',
                productVariantId: String(mainId),
                cartData: data
              });
            }
            var drawer = document.getElementById('Cart-Drawer');
            if (drawer && !drawer.hasAttribute('data-status-silence')) drawer.show(event.submitter);
            else window.location = window.routes.cart_url;
          })
          .catch(function () {
            pf.handleErrorMessage(window.accessibilityStrings?.unknownError);
          })
          .finally(function () {
            pf.endLoading();
          });
      },
      true
    );
  }

  function initAnchors(root) {
    root.querySelectorAll('[data-lp-pdp-anchor]').forEach(function (link) {
      if (link.dataset.lpPdpAnchorInit === 'true') return;
      link.dataset.lpPdpAnchorInit = 'true';
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  }

  function initSpotlight(section) {
    if (!section || section.dataset.lpPdpSpotlightInit === 'true') return;
    section.dataset.lpPdpSpotlightInit = 'true';

    var track = section.querySelector('[data-lp-pdp-spotlight-track]');
    if (!track) return;

    var prev = section.querySelector('[data-lp-pdp-spotlight-prev]');
    var next = section.querySelector('[data-lp-pdp-spotlight-next]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step(dir) {
      track.scrollBy({
        left: dir * Math.max(220, track.clientWidth * 0.65),
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', function () { isDown = false; });
    track.addEventListener('mouseup', function () { isDown = false; });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX);
    });
  }

  function bindVariant(root, variants) {
    function sync(variant) {
      if (!variant) variant = getActiveVariantFromDom(root, variants);
      if (variant) onVariantChange(root, variant);
      else syncPickupVisibility(root);
    }

    if (window.webvista && window.PUB_SUB_EVENTS) {
      webvista.subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var sectionId = root.closest('[data-section]')?.dataset.section;
        if (evt?.data?.sectionId !== sectionId) return;
        sync(evt.data.variant);
        window.setTimeout(function () {
          var priceWrap = root.querySelector('[data-lp-pdp-price]');
          var fetched = document.getElementById('Price-' + sectionId);
          if (priceWrap && fetched) priceWrap.innerHTML = fetched.innerHTML;
          sync(evt.data.variant);
        }, 80);
      });
    }

    sync(findVariant(variants, getVariantId(root)));
  }

  function ensureEcomsendLoaded() {
    window.EcomSendApps = window.EcomSendApps || {};
    window.EcomSendApps.forceImmediateLoad = true;
    try {
      document.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true }));
    } catch (e) {
      document.dispatchEvent(new Event('pointerdown', { bubbles: true }));
    }
  }

  function openSendwillPopup(popupId, attempt) {
    if (!popupId) return;
    attempt = attempt || 0;
    ensureEcomsendLoaded();

    var actions = window.EcomSendApps && window.EcomSendApps.actions;
    if (actions) {
      if (typeof actions.showModal === 'function') {
        actions.showModal(true, false, popupId);
        return;
      }
      if (typeof actions.initHashPopup === 'function') {
        actions.initHashPopup('Ecomsend_popups_open_' + popupId);
        return;
      }
    }

    if (attempt === 0) {
      var hash = 'Ecomsend_popups_open_' + popupId;
      if (window.location.hash.replace(/^#/, '') !== hash) {
        window.location.hash = hash;
      }
    }

    if (attempt < 30) {
      window.setTimeout(function () {
        openSendwillPopup(popupId, attempt + 1);
      }, 200);
    }
  }

  function initPromoBanner(root) {
    var banner = root.querySelector('[data-lp-pdp-promo-banner]');
    if (!banner || banner.dataset.lpPdpPromoInit === 'true') return;
    banner.dataset.lpPdpPromoInit = 'true';

    banner.addEventListener('click', function (evt) {
      var trigger = evt.target.closest('[data-lp-pdp-promo-trigger]');
      if (!trigger) return;

      var popupId = trigger.dataset.sendwillPopupId
        || banner.dataset.sendwillPopupId
        || '';

      if (!popupId) return;

      evt.preventDefault();
      openSendwillPopup(popupId, 0);
    });
  }

  function initStickyBar(root) {
    var sectionId = root.dataset.section || root.closest('[data-section]')?.dataset.section;
    if (!sectionId) return;

    var bar = document.querySelector('[data-lp-pdp-sticky-bar][data-section-id="' + sectionId + '"]');
    if (!bar || bar.dataset.lpPdpStickyInit === 'true') return;
    bar.dataset.lpPdpStickyInit = 'true';

    var purchaseAnchor = document.getElementById('Inventory-' + sectionId) || root.querySelector('.lp-pdp-group--purchase');
    var priceEl = bar.querySelector('[data-lp-pdp-sticky-price]');
    var atcBtn = bar.querySelector('[data-lp-pdp-sticky-atc]');
    var buyBtn = bar.querySelector('[data-lp-pdp-sticky-buy-now]');
    var topBtn = bar.querySelector('[data-lp-pdp-sticky-top]');
    var rafId = 0;

    function getForm() {
      return root.querySelector('product-form form[data-type="add-to-cart-form"]');
    }

    function isLocked() {
      return root.classList.contains('lp-pdp-purchase--locked');
    }

    function mainSubmitButton() {
      return document.getElementById('Product-Submit-Button-' + sectionId);
    }

    function mainBuyNowButton() {
      return document.getElementById('Product-BuyNow-Button-' + sectionId);
    }

    function syncPrice() {
      var source = root.querySelector('[data-lp-pdp-price]');
      if (priceEl && source) priceEl.innerHTML = source.innerHTML;
    }

    function syncButtons() {
      var submit = mainSubmitButton();
      var soldOut = submit ? submit.hasAttribute('disabled') : false;
      if (atcBtn) {
        atcBtn.disabled = soldOut;
        atcBtn.textContent = soldOut && submit
          ? submit.querySelector('.button-text')?.textContent?.trim() || 'Sold out'
          : (atcBtn.dataset.defaultLabel || 'Add to cart');
      }
      if (buyBtn) buyBtn.disabled = soldOut;
    }

    var featureSectionIds = [
      'lp-pdp-overview',
      'lp-connect',
      'lp-wire-free-navigation',
      'lp-smart-mapping',
      'lp-visionmind-ai',
      'lp-durability'
    ];

    function getTopOffset() {
      if (
        document.documentElement.classList.contains('lp-pdp-subnav-pinned') ||
        document.documentElement.classList.contains('lp-pdp-subnav-active')
      ) {
        var subnavHeight = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--lp-pdp-subnav-height')
        );
        if (Number.isFinite(subnavHeight) && subnavHeight > 0) return subnavHeight;
        return 58;
      }

      var headerHeight = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      );
      return Number.isFinite(headerHeight) && headerHeight > 0 ? headerHeight : 72;
    }

    function isElementInViewport(el, topOffset) {
      if (!el) return false;
      var rect = el.getBoundingClientRect();
      var viewportBottom = window.visualViewport
        ? window.visualViewport.height
        : window.innerHeight;
      return rect.top < viewportBottom * 0.92 && rect.bottom > topOffset + 8;
    }

    function hasEnteredOverview(topOffset) {
      var overview = document.getElementById('lp-pdp-overview');
      if (!overview) return false;
      return overview.getBoundingClientRect().top <= topOffset + 32;
    }

    function isInFeatureSections(topOffset) {
      return featureSectionIds.some(function (id) {
        return isElementInViewport(document.getElementById(id), topOffset);
      });
    }

    function hasPassedPurchaseZone(topOffset) {
      if (!purchaseAnchor) return false;
      return purchaseAnchor.getBoundingClientRect().bottom < topOffset + 8;
    }

    function shouldShowStickyBar(topOffset) {
      if (hasEnteredOverview(topOffset)) return true;
      if (isInFeatureSections(topOffset)) return true;
      return hasPassedPurchaseZone(topOffset);
    }

    function getFallbackBarHeight() {
      return window.matchMedia('(min-width: 990px)').matches ? 96 : 148;
    }

    function measureBarHeight() {
      if (!bar.classList.contains('is-visible')) return 0;

      var inner = bar.querySelector('.lp-pdp-sticky-bar__inner');
      var height = Math.ceil(bar.getBoundingClientRect().height);
      if (height < 40 && inner) {
        height = Math.ceil(inner.getBoundingClientRect().height);
      }
      if (height < 40) height = bar.offsetHeight || 0;
      if (height < 40) height = getFallbackBarHeight();

      return height + 12;
    }

    function syncStickyBarHeight(visible) {
      function measure() {
        var height = visible ? measureBarHeight() : 0;
        document.documentElement.style.setProperty('--lp-pdp-sticky-bar-height', height + 'px');
        window.dispatchEvent(new CustomEvent('lp-pdp-sticky-bar-change', { detail: { visible: visible, height: height } }));
      }

      if (visible) {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(measure);
        });
      } else {
        measure();
      }
    }

    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      if (visible) {
        bar.removeAttribute('hidden');
      } else {
        bar.setAttribute('hidden', '');
      }
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.documentElement.classList.toggle('lp-pdp-sticky-bar-visible', visible);
      document.body.classList.toggle('lp-pdp-sticky-bar-visible', visible);
      syncStickyBarHeight(visible);
    }

    function syncVisibility() {
      rafId = 0;
      setVisible(shouldShowStickyBar(getTopOffset()));
    }

    function requestVisibilitySync() {
      if (!rafId) rafId = window.requestAnimationFrame(syncVisibility);
    }

    function triggerMainPurchase(action) {
      if (isLocked()) {
        var lockedBtn = mainBuyNowButton();
        if (lockedBtn) lockedBtn.click();
        return;
      }

      var form = getForm();
      if (!form) return;

      if (action === 'cart') {
        var submit = mainSubmitButton();
        if (submit && !submit.disabled) {
          submit.click();
        }
        return;
      }

      if (action === 'checkout') {
        checkoutFromProductForm(getForm(), buyBtn, 'lp-pdp-sticky-bar');
      }
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        triggerMainPurchase('cart');
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        triggerMainPurchase('checkout');
      });
    }

    if (topBtn) {
      topBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }
    document.documentElement.classList.add('lp-pdp-has-sticky-bar');
    document.documentElement.style.setProperty('--lp-pdp-sticky-bar-height', getFallbackBarHeight() + 'px');

    window.addEventListener('scroll', requestVisibilitySync, { passive: true });
    window.addEventListener('resize', function () {
      requestVisibilitySync();
      if (bar.classList.contains('is-visible')) syncStickyBarHeight(true);
    }, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', requestVisibilitySync, { passive: true });
      window.visualViewport.addEventListener('resize', requestVisibilitySync, { passive: true });
    }

    if (typeof MutationObserver !== 'undefined') {
      var htmlObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          if (mutations[i].attributeName === 'class') {
            requestVisibilitySync();
            break;
          }
        }
      });
      htmlObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }

    window.addEventListener('lp-pdp-subnav-change', requestVisibilitySync);

    if (window.webvista && window.PUB_SUB_EVENTS) {
      webvista.subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        if (!evt || !evt.data || evt.data.sectionId !== sectionId) return;
        window.setTimeout(function () {
          syncPrice();
          syncButtons();
          requestVisibilitySync();
        }, 80);
      });
    }

    syncPrice();
    syncButtons();
    requestVisibilitySync();

    if (typeof ResizeObserver !== 'undefined') {
      var barResizeObserver = new ResizeObserver(function () {
        if (bar.classList.contains('is-visible')) syncStickyBarHeight(true);
      });
      barResizeObserver.observe(bar);
    }

    bar.addEventListener('transitionend', function (evt) {
      if (evt.propertyName === 'transform' && bar.classList.contains('is-visible')) {
        syncStickyBarHeight(true);
      }
    });
  }

  function initRoot(layout) {
    if (layout.dataset.lpPdpInit === 'true') return;
    layout.dataset.lpPdpInit = 'true';

    var variants = parseJson(layout.querySelector('[data-lp-pdp-variants]'), []);
    initFeatureToggle(layout);
    initShopPaymentTerms(layout);
    initPromoBanner(layout);
    initLpPdpBuyNow(layout);
    initNetrtkCheck(layout);
    initPickupLocation(layout);
    initAccessories(layout);
    initAccessoriesCarousel(layout);
    initAnchors(layout);
    initStickyBar(layout);
    bindVariant(layout, variants);
    var initialVariant = findVariant(variants, getVariantId(layout));
    syncShopifyPaymentTermsLine(layout, initialVariant);
    window.setTimeout(function () {
      syncShopifyPaymentTermsLine(layout, findVariant(variants, getVariantId(layout)));
    }, 400);

    var spotlight = layout.querySelector('[data-lp-pdp-spotlight]');
    if (spotlight) initSpotlight(spotlight);
  }

  function boot() {
    document.querySelectorAll('.lp-pdp-layout').forEach(initRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('pageshow', function () {
    resetLpPdpPurchaseUi();
  });

  document.addEventListener('shopify:section:load', function (e) {
    var layout = e.target.querySelector('.lp-pdp-layout');
    if (layout) initRoot(layout);
    var spotlight = e.target.querySelector('[data-lp-pdp-spotlight]');
    if (spotlight) initSpotlight(spotlight);
  });
})();
